<template>
  <!-- 
    画面: 割引プラン会員一覧
    用途: オペレータが割引プランに関連する会員を参照する
   -->
  <div>
    <CRow>
      <CCol lg="12">

        <!-- #region 割引プラン情報 -->
        <DiscountInfo />
        <!-- #endregion 割引プラン情報 -->

        <!-- #region 割引プラン会員一覧 -->
        <DiscountMemberListTable />
        <!-- #endregion 割引プラン会員一覧 -->

      </CCol>
    </CRow>

  </div>
</template>

<script>
import DiscountInfo from "./components/DiscountInfo.vue";
import DiscountMemberListTable from "./components/DiscountMemberListTable.vue";

export default {
  components: {
    DiscountInfo,
    DiscountMemberListTable,
  },
};
</script>

